/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OdbFormularyDrug } from './OdbFormularyDrug';
import {
    OdbFormularyDrugFromJSON,
    OdbFormularyDrugFromJSONTyped,
    OdbFormularyDrugToJSON,
} from './OdbFormularyDrug';
import type { OdbLimitedUseCriteria } from './OdbLimitedUseCriteria';
import {
    OdbLimitedUseCriteriaFromJSON,
    OdbLimitedUseCriteriaFromJSONTyped,
    OdbLimitedUseCriteriaToJSON,
} from './OdbLimitedUseCriteria';

/**
 * Complete ODB drug information including Limited Use criteria
 * @export
 * @interface OdbDrugInfo
 */
export interface OdbDrugInfo {
    /**
     * 
     * @type {OdbFormularyDrug}
     * @memberof OdbDrugInfo
     */
    drug?: OdbFormularyDrug;
    /**
     * 
     * @type {Array<OdbLimitedUseCriteria>}
     * @memberof OdbDrugInfo
     */
    lu_criteria?: Array<OdbLimitedUseCriteria>;
}

/**
 * Check if a given object implements the OdbDrugInfo interface.
 */
export function instanceOfOdbDrugInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OdbDrugInfoFromJSON(json: any): OdbDrugInfo {
    return OdbDrugInfoFromJSONTyped(json, false);
}

export function OdbDrugInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdbDrugInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'drug': !exists(json, 'drug') ? undefined : OdbFormularyDrugFromJSON(json['drug']),
        'lu_criteria': !exists(json, 'lu_criteria') ? undefined : ((json['lu_criteria'] as Array<any>).map(OdbLimitedUseCriteriaFromJSON)),
    };
}

export function OdbDrugInfoToJSON(value?: OdbDrugInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drug': OdbFormularyDrugToJSON(value.drug),
        'lu_criteria': value.lu_criteria === undefined ? undefined : ((value.lu_criteria as Array<any>).map(OdbLimitedUseCriteriaToJSON)),
    };
}

